import { Component, Input } from '@angular/core';

@Component({
	selector: 'cmv-full-size-loading',
	templateUrl: './full-size-loading.component.html',
	styleUrls: ['./full-size-loading.component.scss'],
})
export class FullSizeLoadingComponent {
	@Input() loadingMessage = 'Cargando...';
	@Input() isModalOpen = false;
	constructor() {}
}
